import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
let baseUrl3 = `${httpUrl.host}/gy-auth`
let baseUrl4 = `${httpUrl.host}/gy-config`
// let baseUrl = '/api/gy-apartment'

let api = {
  // 住户待办通过
  approveBaklogByCode: `${baseUrl}/baklog/approveBaklogByCode`,

  // 获取审批数量
  getCountApproveForMe: `${baseUrl2}/homePage/getCountApproveForMe`,

  // 人员待办通过
  approvePersonBaklog: `${baseUrl}/baklog/approveBaklogByCode`,

  // 根据待办编号获取待办详情
  getBaklogByCode: `${baseUrl}/baklog/getBaklogByCode`,

  // 获取当前登录账号有几条代办记录
  getBaklogCountByAccountCode: `${baseUrl}/baklog/getBaklogCountByAccountCode`,

  // 获取待办分页记录
  getBaklogPage: `${baseUrl}/baklog/getBaklogPage`,

  // 驳回待办
  unApproveBaklogByCode: `${baseUrl}/baklog/unApproveBaklogByCode`,

  // 获取园区信息
  getYqInfo: `${baseUrl2}/gyInfo/getYqInfo`,

  // 获取单个子账号信息
  getAccountByCode: `${baseUrl3}/account/getByCode`,

  // 退出
  logout: `${baseUrl3}/logout`,

  // 获取平台端服务开通信息
  getYqServerConfig: `${baseUrl4}/config/getList`,

  // 获取投诉建议分页
  getSuggestionsPage: `${baseUrl}/suggestions/getPage`,

  // 获取投诉建议详情
  getSuggestionsByCode: `${baseUrl}/suggestions/getByCode`,

  // 修改投诉建议
  changeSuggestionsStatus: `${baseUrl}/suggestions/changeStatus`,

  // 修改子账号密码
  changePassword: `${baseUrl3}/account/changePassword`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/User.js